





























































import Vue, { PropType } from "vue";

import CustomInputJson from "../../shared/CustomInputJson";
import { CustomInputCategory } from "../../shared/CustomInputCategory";
import { CustomInputType } from "../../shared/CustomInputType";

export default Vue.extend({
  name: "CustomInputView",
  components: {},
  props: {
    data: Array as PropType<CustomInputJson[]>,
    category: String as PropType<CustomInputCategory>,
    editable: Boolean,
    customId: String,
    gap: String,
    validation: Array,
    submitValidation: Boolean,
  },
  data() {
    return {
      CustomInputCategory: CustomInputCategory,
      CustomInputType: CustomInputType,
      details: null as CustomInputJson[] | null,
      toValidate: {} as any,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.details = this.data;
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "customInputs-" + this.inputId, key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },
  },
  watch: {
    data() {
      this.details = this.data;
    },

    details: {
      handler(val, oldVal) {
        this.$emit("change", this.details);
      },
      deep: true,
    },
  },
  computed: {
    inputId(): string {
      if (this.customId) {
        return this.customId;
      } else {
        return this.category;
      }
    },

    hasItem(): boolean {
      if (this.details) {
        let filteredDetails = this.details.filter((i: CustomInputJson) => i.category == this.category);
        if (filteredDetails && filteredDetails.length > 0) return true;
      }

      return false;
    },

    isAprovel(): boolean {
      return this.category == CustomInputCategory.aprovel ? true : false;
    },
  },
});
